module.exports = __webpack_public_path__ + "c88397eabc61b0cd856c63dba9af15f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3.jpg
// module id = 229
// module chunks = 0